import React, { useEffect, useState } from 'react'
import Button from '../../components/Button'
import { useDispatch, useSelector } from 'react-redux';
import {
    getTanggalTerbitSoal,
    updateTanggalTerbitSoal,
    updateStatePengaturan,
    getBatasWaktu
} from '../../features/pengaturanSlice';
import PilihTanggal from "../../components/jurnal/PilihTanggal";

function TerbitSoal() {
    const [date, setDate] = useState(null);
    const dispatch = useDispatch()
    const [isEditing, setIsEditing] = useState(false);
    const { loadingTerbitSoal, terbitSoalTanggal } = useSelector(state => state.pengaturan)

    useEffect(() => {
        dispatch(getTanggalTerbitSoal()).then((res) => {
            if (res.payload?.data?.value) {
                const [year, month, day] = res.payload.data.value.split('-')
                setDate(new Date(year, month - 1, day))
            }
        })
    }, [])

    function handleSimpan() {
        dispatch(updateTanggalTerbitSoal(terbitSoalTanggal))
        setIsEditing(false)
    }

    function handleEdit() {
        setIsEditing(!isEditing)
    }
    function handleBatal() {
        setIsEditing(false)
        dispatch(getTanggalTerbitSoal())

    }

    return (
        <div className='batas-waktu'>
            <h1>Terbit soal</h1>

            <div className='containers-input'>
                <style>{`.terbit-soal-calendar .react-calendar { width: 550px !important; max-width: none !important; }`}</style>
                <div className='wrapper-pilih-tanggal terbit-soal-calendar' style={!isEditing ? { pointerEvents: 'none', opacity: 0.6 } : {}}>
                    <PilihTanggal
                        text={terbitSoalTanggal}
                        setText={updateStatePengaturan}
                        stateText='terbitSoalTanggal'
                        setDate={setDate}
                        date={date}

                        setTime={updateStatePengaturan}
                        stateTime='terbitSoalTanggal'
                    />
                </div>
            </div>

            <div className='wrapper-btn'>

                {!isEditing &&
                    <Button text={'Edit'} className={'edit-btn'} onClick={handleEdit} />
                }
                {isEditing &&
                    <>
                        <Button text={'Batal'} className={'batal-btn'} onClick={handleBatal} />
                        <Button text={'Simpan'} className={'simpan-btn'} onClick={handleSimpan} />
                    </>
                }
            </div>
        </div>
    )
}

export default TerbitSoal